export const datesOfDeathAnomalies = [
  'Aug 19 2020',
  'Sep 4 2020',
  'Sep 11 2020',
  'Oct 2 2020',
  'Oct 3 2020',
];

export const datesOfLTCDeathAnomalies = [
  'Jun 17 2020',
  'Jun 22 2020',
  'Jul 16 2020',
];
